export default {
  header: 'Specyfikacja audytu',
  specificationName: 'Nazwa specyfikacji',
};
